import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { PlusIcon } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import AccountQuickView from "./popup";
import XCloseIcon from "../../../../component/icons/x-close";
import ProjectQuickView from "../../../projects/project/popup";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import Tooltip from "../../../../component/ui/tooltip";
import EmployeeDirectoryAddUpdate from "../../../organization/emplyee-directory/add-update";
import LeadQuickView from "../../../mainleads/leads/lead/popup";
import ContactQuickView from "../../../mainAccounts/accounts/contact/popup";
import DealQuickView from "../../../mainDeals/deals/deal/popup";
import AddSales from "../../add-sales/add-sales";

const OrganizationSale = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [changeModal, setChangeModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentStatus, setCurrentStatus] = useState("");
  const [brands, setBrands] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [popupData, setPopupData] = useState({ type: null, data: null });
  const [showModal, setShowModal] = useState(false);
  const [UsersList, setUsersList] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [entityData, setEntityData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);

  // modal
  const [showQaModal, setShowQaModal] = useState(false);
  const [qaFormData, setQaFormData] = useState(null);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    fetchUsers();
    fetchEntities();
    getPackages();
  }, []);

  const fetchUsers = async () => {
    if (loadingUsers) return;
    setLoadingUsers(true);

    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsersList(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setLoadingUsers(false);
    }
  };

  const fetchEntities = async (search = "") => {
    try {
      const res = await apiCall({
        method: "get",
        url: `activities/get-activity-type?search=${encodeURIComponent(
          search
        )}`,
      });

      const list = res?.data || []; // 👈 safe access to data array

      setEntityData(
        list.map((item) => ({
          id: item.id,
          name: item.name,
          type: item.type,
        }))
      );
    } catch (error) {
      console.error("Error fetching entities:", error);
    }
  };

  const [packages, setPackages] = useState([]);

  const getPackages = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `packages/packages-list`,
      });
      setPackages(res?.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const handleEdit = (eachActivity) => {
    setPopupData({ type: "edit", data: eachActivity });
    setShowModal(true);
  };

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `?page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `sales-report${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);

      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setSelectedIds([]);
    getData({});
    setChangeModal(false);
    setShowQaModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const filterModalData = [
    {
      name: "project_filter",
      label: "Project",
      options: ["is", "contains"],
      selectedOpt: "is",
      value: "",
      type: "text",
    },
    {
      name: "package",
      label: "Package",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: packages,
      dropdownKey: "packagename",
      dropdownVal: "packagename",
    },
    {
      name: "sale_by",
      label: "Sale By",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: UsersList,
      dropdownKey: "name",
      dropdownVal: "name",
    },
    {
      name: "support_pm",
      label: "Support",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: UsersList,
      dropdownKey: "name",
      dropdownVal: "name",
    },
    {
      name: "time",
      label: "Time",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "today", value: "today" },
        { label: "yesterday", value: "yesterday" },
        { label: "7days", value: "7days" },
        { label: "thismonth", value: "thismonth" },
        { label: "previousmonth", value: "previousmonth" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
    },
  ];

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody}`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              <TableFilterReturn
                filterReturn={filterReturn}
                onChange={(allFilter) => {
                  setFilterReturn(allFilter);
                  getData({ filter: allFilter });
                }}
              />
              {/* HEADER */}

              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  <div className={Style.bpfl_select}>
                    <select
                      onChange={(e) => {
                        getData({ page_quantity: e?.target.value });
                        setPageCount(1);
                        setPageItemsCount(e?.target.value);
                      }}
                    >
                      <option value="10">View 10</option>
                      <option value="25">View 25</option>
                      <option value="50">View 50</option>
                      <option value="100">View 100</option>
                      <option value="all">View all</option>
                    </select>
                  </div>
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    {/* Add lead Button */}

                    <div
                      className={Style.bpfl_action}
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      <Tooltip
                        content={"Add"}
                        position={"left center"}
                        className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                      >
                        <div className={Style.icon}>
                          <PlusIcon size="1em" />
                        </div>
                      </Tooltip>
                    </div>

                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          filterReturn?.length ? Style.active : null
                        }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              <div className={Style.empDirectory_body}>
                {/* BODY */}

                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <div className="flex justify-center items-center w-full h-full">
                    <DataNotFound title={"Sales"} />
                  </div>
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <TableHeaderWrap>
                                <span className="pl-[50px]">Client Name</span>
                              </TableHeaderWrap>
                            </TableCell>

                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                              eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    <div className="flex items-center gap-3">
                                      {eachList?.client_name ? (
                                        <>
                                          <div>
                                            <div className="font-medium leading-5">
                                              {eachList?.client_name}
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        "-"
                                      )}
                                    </div>

                                    <div
                                      className={Style.tableActionAreaBtnGrpup}
                                    >
                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#FF9500" }}
                                          onClick={() => {
                                            setQaFormData({
                                              transaction_id:
                                                eachList?.transaction_id,
                                              sale_authorized:
                                                eachList?.sale_authorized,
                                              merchant_description:
                                                eachList?.merchant_description,
                                              wrong_sale: eachList?.wrong_sale,
                                              comments_by_qa:
                                                eachList?.comments_by_qa,
                                              wrong_sale_comment:
                                                eachList?.wrong_sale_comment,
                                            });
                                            setShowQaModal(true);
                                          }}
                                        >
                                          <NewEditIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#007AFF" }}
                                        >
                                          <NewEyeIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>

                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 &&
                                  eachHead.show == 1 ? (
                                    <TableCell
                                      key={`${i}-${index}`}
                                      className="text-center capitalize"
                                    >
                                      {eachList[eachHead.key] === 1
                                        ? "Yes"
                                        : eachList[eachHead.key] === 0
                                        ? "No"
                                        : eachList[eachHead.key] ?? "-"}
                                    </TableCell>
                                  ) : null
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>

              {!isLoading && apiData?.length > 0 ? (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    {`showing 1 to ${apiData?.length} of ${
                      tablePagination?.total || apiData?.length
                    }`}
                  </div>

                  {tablePagination ? (
                    <div className={Style.empDirectory_footer}>
                      {tablePagination?.next_page_url ? (
                        <button
                          className={Style.loadMoreBtn}
                          onClick={() => {
                            if (btnLoader) return;
                            setBtnLoader(true);
                            getData({
                              page: tablePagination?.next_page_url,
                            });
                          }}
                        >
                          {btnLoader ? (
                            <InnerLoader
                              className={Style.loader}
                              textStatus={false}
                            />
                          ) : (
                            "Load More"
                          )}
                        </button>
                      ) : null}
                    </div>
                  ) : null}

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-activities"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="get-activities"
        />
      )}

      {popupData?.entity_type === "deal" && (
        <DealQuickView
          data={{ ...popupData, dealid: popupData?.entity_id }}
          onClose={() => setPopupData({ type: null, data: null })}
        />
      )}

      {popupData?.entity_type === "contact" && (
        <ContactQuickView
          data={{ ...popupData, userid: popupData?.entity_id }}
          onClose={() => setPopupData({ type: null, data: null })}
        />
      )}
      {popupData?.entity_type === "lead" && (
        <LeadQuickView
          data={{ ...popupData, leadid: popupData?.entity_id }}
          onClose={() => setPopupData({ type: null, data: null })}
        />
      )}

      {popupData?.entity_type === "project" && (
        <ProjectQuickView
          data={{ ...popupData, projectkey: popupData?.entity?.projectkey }}
          onClose={() => setPopupData({ type: null, data: null })}
        />
      )}

      {popupData?.entity_type === "account" && (
        <AccountQuickView
          data={{ ...popupData, userid: popupData?.entity_id }}
          onClose={() => setPopupData({ type: null, data: null })}
        />
      )}

      {showModal && (
        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setShowModal(false);
            setPopupData({ type: null, data: null });
          }}
          data={popupData?.data || {}}
          tabIndex={2}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {showQaModal && (
        <AddSales
          qaFormData={qaFormData}
          onSubmit={onSuccess}
          onError={onError}
          onClose={() => setShowQaModal(false)}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default OrganizationSale;
